import { useEffect, useState } from "react";
import { AlertTriangle, EyeOff, Eye } from "lucide-react";
import { http } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const isBlockingClosed = (r) => r?.status === "closed" && !r.acknowledged;

export const confirmClosedClient = async (clientId) => {
  if (!clientId) return true;
  const r = await http.get(`/clients/${clientId}/registry-check`, { params: { live: false } }).then((x) => x.data).catch(() => null);
  if (!isBlockingClosed(r)) return true;
  return window.confirm(`${r.source === "vies" ? "N° de TVA intracommunautaire invalide" : r.source === "uk" ? "Entreprise fermée au registre britannique" : r.source === "ch" ? "Entreprise radiée ou en liquidation au registre du commerce suisse" : "Établissement fermé dans l'annuaire des entreprises"}${r.registry_name ? ` (${r.registry_name})` : ""}.\n\nContinuer quand même ?`);
};

export const useClientRegistry = (clientId) => {
  const [r, setR] = useState(null);
  useEffect(() => {
    setR(null);
    if (!clientId) return;
    let alive = true;
    http.get(`/clients/${clientId}/registry-check`).then((x) => alive && setR(x.data)).catch(() => {});
    return () => { alive = false; };
  }, [clientId]);
  return [r, setR];
};

export const ClosedClientBanner = ({ clientId, registry, setRegistry }) => {
  const { user } = useAuth();
  if (registry?.status !== "closed") return null;
  const isAdmin = user?.role === "admin";
  const toggle = async (ack) => { const { data } = await http.post(`/clients/${clientId}/registry-ack`, { ack }); setRegistry(data); };
  if (registry.acknowledged) {
    return (
      <div data-testid="closed-client-acked" className="md:col-span-2 text-xs text-slate-500 flex items-center gap-2">
        <EyeOff className="h-3.5 w-3.5" />Avertissement « établissement fermé » retiré par {registry.ack_by}.
        {isAdmin && <button type="button" data-testid="closed-client-restore-btn" onClick={() => toggle(false)} className="underline inline-flex items-center gap-1"><Eye className="h-3.5 w-3.5" />Rétablir</button>}
      </div>
    );
  }
  return (
    <div data-testid="closed-client-banner" className="md:col-span-2 flex flex-wrap items-center gap-3 px-4 py-3 rounded-md border border-rose-300 bg-rose-50 text-rose-800 text-sm">
      <AlertTriangle className="h-5 w-5 shrink-0" />
      <span className="flex-1"><b>{registry.source === "vies" ? "N° de TVA intracommunautaire invalide" : registry.source === "uk" ? `Entreprise fermée au registre britannique${registry.label ? ` (${registry.label})` : ""}` : registry.source === "ch" ? `Entreprise ${(registry.label || "radiée").toLowerCase()} au registre du commerce suisse` : "Établissement fermé"}</b>{registry.source === "fr" || !registry.source ? " dans l'annuaire officiel des entreprises" : ""}{registry.registry_name ? ` (${registry.registry_name})` : ""}. Vérifiez la situation du client avant d&apos;émettre ce document.</span>
      {isAdmin && <button type="button" data-testid="closed-client-ack-btn" onClick={() => toggle(true)} className="text-xs font-semibold px-2.5 py-1.5 rounded border border-rose-400 bg-white hover:bg-rose-100">Retirer l&apos;avertissement</button>}
    </div>
  );
};
